import { ICategory, IkeywordsByType } from 'types';
import { generateCategoriesKeywords } from './dataGenerators';

export const checkCategories = (rowValues: ICategory, setValue: (value: React.SetStateAction<ICategory[]>) => void) => {
    if (rowValues.level === 'category') {
        setValue((prev) => {
            const newData = [...prev];
            const index = newData.findIndex((c) => c.id === rowValues.id);
            newData[index].checked = !newData[index].checked;
            newData[index].subRows = newData[index].subRows.map((subcategory) => ({
                ...subcategory,
                checked: newData[index].checked,
                subRows: subcategory.subRows.map((segment) => ({
                    ...segment,
                    checked: newData[index].checked,
                })),
            }));
            return newData;
        });
    }
    if (rowValues.level === 'subcategory') {
        setValue((prev) => {
            const newData = [...prev];
            const categoryIndex = newData.findIndex((c) => c.id === rowValues.parentId?.id);
            if (categoryIndex !== -1) {
                const subcategoryIndex = newData[categoryIndex].subRows.findIndex((c) => c.id === rowValues.id);
                if (subcategoryIndex !== -1) {
                    newData[categoryIndex].subRows[subcategoryIndex].checked =
                        !newData[categoryIndex].subRows[subcategoryIndex].checked;
                    const allSubcategoriesChecked = newData[categoryIndex].subRows.every(
                        (subcategory) => subcategory.checked,
                    );

                    newData[categoryIndex].checked = allSubcategoriesChecked;

                    newData[categoryIndex].subRows[subcategoryIndex].subRows = newData[categoryIndex].subRows[
                        subcategoryIndex
                    ].subRows.map((segment) => ({
                        ...segment,
                        checked: newData[categoryIndex].subRows[subcategoryIndex].checked,
                    }));
                }
            }
            return newData;
        });
    }

    if (rowValues.level === 'segment') {
        setValue((prev) => {
            const newData = [...prev];
            const categoryIndex = newData.findIndex((c) => c.id === rowValues.parentId?.parentId?.id);
            if (categoryIndex !== -1) {
                const subcategoryIndex = newData[categoryIndex].subRows.findIndex(
                    (c) => c.id === rowValues.parentId?.id,
                );
                if (subcategoryIndex !== -1) {
                    const segmentIndex = newData[categoryIndex].subRows[subcategoryIndex].subRows.findIndex(
                        (c) => c.id === rowValues.id,
                    );
                    if (segmentIndex !== -1) {
                        newData[categoryIndex].subRows[subcategoryIndex].subRows[segmentIndex].checked =
                            !newData[categoryIndex].subRows[subcategoryIndex].subRows[segmentIndex].checked;
                        const allSegmentsChecked = newData[categoryIndex].subRows[subcategoryIndex].subRows.every(
                            (segment) => segment.checked,
                        );

                        newData[categoryIndex].subRows[subcategoryIndex].checked = allSegmentsChecked;

                        const allSubcategoriesChecked = newData[categoryIndex].subRows.every(
                            (subcategory) => subcategory.checked,
                        );

                        newData[categoryIndex].checked = allSubcategoriesChecked;
                    }
                }
            }
            return newData;
        });
    }
};

export const updateKeywordsByType = (
    cat: ICategory[],
    setValue: (value: React.SetStateAction<IkeywordsByType[]>) => void,
): void => {
    const categoriesKeywords = generateCategoriesKeywords(cat, true);
    setValue((prev) => {
        return prev.map((e) => {
            e.keywords = e.keywords.map((keyword) => {
                const newKeyword = { ...keyword };
                newKeyword.checked = categoriesKeywords.includes(Number(newKeyword.id));
                return newKeyword;
            });
            return e;
        });
    });
};

export const toggleCategory = (rowValues: ICategory, setValue: (value: React.SetStateAction<ICategory[]>) => void) => {
    if (rowValues.level === 'category') {
        setValue((prev) => {
            const newData = [...prev];
            const index = newData.findIndex((c) => c.id === rowValues.id);
            newData[index].isExpanded = !newData[index].isExpanded;
            return newData;
        });
    }
    if (rowValues.level === 'subcategory') {
        setValue((prev) => {
            const newData = [...prev];
            newData.forEach((category, i) => {
                const index = category.subRows.findIndex((c) => c.id === rowValues.id);
                if (index !== -1) {
                    newData[i].subRows[index].isExpanded = !newData[i].subRows[index].isExpanded;
                }
            });
            return newData;
        });
    }
};

export const areChildrenChecked = (catData: ICategory[]): boolean => {
    return catData.some((item) => {
        if (item.subRows && item.subRows.length) {
            return areChildrenChecked(item.subRows);
        }
        return item.checked;
    });
};
